import React, { useEffect } from "react";
import { Col, Row } from "antd";
import { useLocation } from "react-router-dom";

const Terms = () => {
  const targetRef = React.useRef(null);
  const location = useLocation();
  useEffect(() => {
    if (location.hash === "#politica_de_privacidad_y_seguridad") {
      scrollToTarget();
    }
  }, [location]);

  const scrollToTarget = () => {
    setTimeout(() => {
      targetRef.current.scrollIntoView({
        behavior: "smooth",
      });
    }, 500);
  };
  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl pb-12 m-10">
      <Row>
        <Col className="mb-4" span="24">
          <h1>
            <strong>TÉRMINOS Y CONDICIONES DE USO LA PLATAFORMA MOTIVIA</strong>
          </h1>

          <ol className="text-xl text-black">
            <li>
              <h2 className="text-xl">Aspectos generales</h2>
              <p className="text-sm text-justify opacity-60">
                Adium es una plataforma de registro de datos personales de salud
                que permite a los usuarios individuales y profesionales
                interactuar mediante programas de salud basados en el monitoreo
                y la promoción de hábitos saludables. En este sentido, el
                Usuario entiende y acepta que Adium es un medio alternativo al
                vínculo tradicional médico paciente plenamente alcanzado por la
                legislación que regula la actividad, en especial frente a
                situaciones relacionadas con ética profesional, secreto médico,
                intangibilidad de la historia clínica y confidencialidad de
                información y de los datos personales de los Usuarios.
              </p>
              <p className="text-sm text-justify opacity-60">
                Estos términos y condiciones de uso de la Plataforma, describen
                todos los términos y condiciones aplicables al uso de nuestro
                sitio de Adium alojado en{" "}
                <a href="https://www.motivia.co">www.motivia.co</a> y las
                aplicaciones para dispositivos móviles de Adium (en adelante,
                “la Plataforma”) y los servicios disponibles a través de la
                Plataforma (en adelante, “los Servicios”) regulan el uso que,
                cualquier persona que acceda y utilice la Plataforma, incluyendo
                a los visitantes, compradores, clientes y cualquier otra persona
                que interactúa directa o indirectamente con la Plataforma (en
                adelante, los “Usuarios”).
              </p>
              <p className="text-sm text-justify opacity-60">
                Es responsabilidad del Usuario leer atentamente estos términos y
                condiciones antes de empezar a usar la Plataforma. Al acceder a
                la Plataforma se entiende que el Usuario ha leído, entendido y
                aceptado estos Términos y Condiciones que le son legalmente
                vinculantes. Si el Usuario no acepta estos Términos y
                Condiciones o si el Usuario es menor de 18 años no debe usar la
                Plataforma.
              </p>
              <p className="text-sm text-justify opacity-60">
                Este documento contiene información legal, de carácter
                obligatorio y vinculante, que debe ser leída y aceptada
                completamente en conjunto con la Política de Tratamiento de
                Datos Personales disponible en la Plataforma.
              </p>
              <p className="text-sm text-justify opacity-60">
                Adium es una Plataforma que busca acercar a sus Usuarios
                contenidos y herramientas para el cuidado de la salud brindados
                por profesionales médicos que cuentan con todas las licencias y
                requisitos para brindar los Servicios (en adelante,
                “Profesionales”).
              </p>
            </li>
            <li>
              <h2 className="text-xl">Información</h2>
              <p className="text-sm text-justify opacity-60">
                La Plataforma es controlada y operada por{" "}
                <strong>EIRA HEALTHCARE SAS</strong>, CUIT 30-71744815-0, con
                domicilio en E57 KM16, Barrio Cuatro Hojas, Mendiolaza, CP 5107,
                Provincia de Córdoba, República Argentina, único propietario de
                la marca que para los efectos de los presentes términos se
                denominará Adium. EIRA HEALTHCARE S.A.S. se encuentra
                constituido bajo la legislación de la República Argentina.
              </p>
            </li>
            <li>
              <h2 className="text-xl">Naturaleza jurídica</h2>
              <p className="text-sm text-justify opacity-60">
                Los presentes Términos y Condiciones de uso regulan la relación
                contractual de carácter comercial que vincula al cliente,
                paciente o cualquier clase de Usuario, que acceda a la
                Plataforma de Adium con EIRA HEALTHCARE S.A.S.
              </p>
            </li>
            <li>
              <h2 className="text-xl">
                Aceptación de términos y condiciones, consentimiento del Usuario
              </h2>
              <p className="text-sm text-justify opacity-60">
                Al visitar o utilizar de cualquier forma la Plataforma, el
                Usuario manifiesta y admite haber leído y entendido los
                presentes Términos y Condiciones y está de acuerdo con sujetarse
                a los mismos y cumplir con todas las leyes y reglamentos
                aplicables que hagan parte de la legislación de Argentina. En
                caso de que el Usuario no esté de acuerdo con estos Términos y
                Condiciones, debe abstenerse de usar la Plataforma. Adium se
                reserva el derecho a actualizar o cambiar los Términos y
                Condiciones en cualquier momento sin previo aviso. La Plataforma
                puede ser usada únicamente bajo los presentes Términos y
                Condiciones. El uso de la Plataforma se realizará bajo la única
                y exclusiva responsabilidad del Usuario. La Plataforma de Adium
                puede ser utilizada únicamente con fines legales y lícitos.
                Están prohibidas las actividades que impliquen el uso indebido
                de la Plataforma, tales como falsear la identidad de un usuario
                y llevar a cabo actividades fraudulentas a través de la
                Plataforma.
              </p>
              <p className="text-sm text-justify opacity-60">
                Adium, a su entera discreción, se reserva el derecho de negar o
                suspender el acceso a la Plataforma por parte de cualquier
                Usuario que hubiere desconocido estos Términos y Condiciones,
                sin necesidad de notificación previa y sin que ello genere algún
                derecho a indemnización o resarcimiento al Usuario.
              </p>
              <p className="text-sm text-justify opacity-60">
                Al usar la Plataforma y aceptar estos Términos y Condiciones, el
                Usuario brinda consentimiento expreso a Adium para:
              </p>
              <ol className="list-roman text-sm text-justify opacity-60 mb-4">
                <li>
                  tratar documentación y registros médicos que el Usuario
                  brinde;
                </li>
                <li>
                  usar tecnología para la prestación de servicios de atención
                  médica;
                </li>
                <li>proporcionar información a los Profesionales</li>
                <li>
                  coordinar llamadas de audio o video, grabaciones y
                  transcripciones;
                </li>
                <li>acceder a la identidad y ubicación del Usuario;</li>
                <li>enviar publicidad sobre Servicios;</li>
              </ol>
            </li>
            <li>
              <h2 className="text-xl">Condiciones de Uso de la Plataforma</h2>
              <p className="text-sm text-justify opacity-60">
                El ingreso y/o uso de la Plataforma por parte del Usuario deberá
                hacerse teniendo en cuenta, entre otras, las siguientes
                condiciones particulares, por las cuales, El Usuario se obliga a
                mantener indemne a Adium, por lo que se obliga a:
              </p>
              <ol className="list-roman text-sm text-justify opacity-60 mb-4">
                <li>
                  Respetar estos Términos y Condiciones de uso, así como
                  cualquier otra condición establecida en la Plataforma.
                </li>
                <li>
                  Cumplir con todas las leyes, normas y reglamentos aplicables
                  al acceso, uso y consulta de sitios en internet.
                </li>
                <li>
                  Mantener indemne a Adium por reclamos de terceros que surjan
                  por cualquier acto ilícito o lesivo contra la Plataforma que,
                  de cualquier forma, pueda generar o causar perjuicio o impedir
                  el normal funcionamiento de ésta.
                </li>
                <li>
                  Suministrar información real, actualizada, completa y
                  verdadera.
                </li>
                <li>Mantener actualizada la información suministrada</li>
                <li>
                  Asumir cualquier riesgo proveniente de un error o
                  desactualización en la información suministrada
                </li>
                <li>
                  Aceptar todos los riesgos de acceso no autorizado a su cuenta
                </li>
                <li>
                  Recibir y aceptar las comunicaciones enviadas por el equipo de
                  Adium, conforme a las finalidades expuestas en la Política de
                  Protección de Datos Personales disponible en la Plataforma.
                </li>
              </ol>
              <p className="text-sm text-justify opacity-60">
                El Usuario brinda total consentimiento y facultad a Adium de
                tratar datos personales y sensibles cuando ello sea necesario
                para el correcto funcionamiento de la Plataforma, con la
                finalidad de brindar un correcto Servicio.
              </p>
              <p className="text-sm text-justify opacity-60">
                El Usuario se compromete a utilizar la Plataforma, sus servicios
                y contenidos en un todo de acuerdo con la legislación aplicable
                de la República Argentina para su uso personal, atendiendo la
                buena fe y el orden público.
              </p>
              <p className="text-sm text-justify opacity-60">
                El Usuario puede informar, enviando un correo electrónico a la
                cuenta <a href="mailto:info@motivia.co">info@motivia.co</a> su
                deseo de no ser contactado para fines publicitarios o de
                mercadeo. En todo caso los datos personales del Usuario serán
                utilizados por Adium para fines operativos y logísticos del
                estado y entrega de sus productos, incluyendo la respectiva
                facturación (cuando ello aplique).
              </p>
              <p className="text-sm text-justify opacity-60">
                El Usuario de la Plataforma responderá por cualquier perjuicio o
                daño causado a Adium por el uso indebido de ésta y por cualquier
                infracción e incumplimiento de estos Términos y Condiciones de
                uso.
              </p>
              <p className="text-sm text-justify opacity-60">
                Adium no confiere a los Usuarios ninguna licencia para
                descargar, reproducir, copiar, enmarcar, compilar, cargar o
                republicar, adaptar, modificar, transmitir, vender ni comunicar
                al público, total o parcialmente ninguna herramienta y/o
                contenido de la Plataforma. Cualquiera de estas actividades
                requiere de la autorización previa, expresa y por escrito de
                Adium, so pena de incurrir en violación a los derechos de
                propiedad industrial y derechos de autor, y someterse a las
                consecuencias civiles y penales de tal hecho.
              </p>
              <p className="text-sm text-justify opacity-60">
                La entrega de información por parte del Usuario para la creación
                de su perfil y/o la información necesaria para acceder a
                cualquier producto y/o servicio será responsabilidad únicamente
                del Usuario. Errores en la escritura, diligenciamiento y
                veracidad de la información no generarán responsabilidad alguna
                a Adium y el Usuario será el único responsable por las
                consecuencias que la indebida proporción de información pueda
                generar en la prestación del servicio. El Usuario tiene el
                derecho de solicitar el cambio de los datos personales
                introducidos en la Plataforma, siguiendo el proceso descripto en
                la Política de Privacidad de Datos de Adium, publicado en la
                Plataforma.
              </p>
              <p className="text-sm text-justify opacity-60">
                Al navegar en el sitio y utilizar la Plataforma, al expresar sus
                opiniones y comentarios y/o participar en forma interactiva de
                alguno de los servicios ofrecidos en el mismo el Usuario se
                compromete a no enviar o transmitir contenido alguno que:
              </p>
              <ol className="list-lower-alpha text-sm text-justify opacity-60 mb-4">
                <li>
                  Induzca o incite a actuar en forma ilegal o constituyan en si
                  mismas infracciones a la legislación vigente en la Repùblica
                  Argentina o en cualquier otro ordenamiento jurídico.
                </li>
                <li>
                  Perjudique o impida, pueda dañar y/o sobrecargar, de cualquier
                  forma, la utilización y normal funcionamiento de la Plataforma
                  directa o indirectamente atente contra los mismos o contra
                  cualquier derecho de un tercero.
                </li>
                <li>
                  Incorpore elementos, contenidos, mensajes, formatos o
                  fotografías de contenido ilícito, violento, difamante,
                  pornográfico, degradantes o irrespetuoso de los miembros de la
                  comunidad o de terceros. Tampoco está permitido realizar estas
                  actividades con fines publicitarios o comerciales.
                </li>
              </ol>
              <p className="text-sm text-justify opacity-60">
                Adium se reserva el derecho de suspender, interrumpir, suprimir
                contenidos o prohibir el acceso a quienes infrinjan estas
                normas, pudiendo hacerlo sin previo aviso en aquellos casos en
                que lo considere de especial gravedad.
              </p>
            </li>
            <li>
              <h2 className="text-xl">Cuenta de usuario</h2>
              <p className="text-sm text-justify opacity-60">
                Para poder acceder a algunas funcionalidades de la Plataforma es
                necesario el registro por parte del Usuario. El perfil o cuenta
                de Usuario creado es la cuenta personal única que acredita el
                registro en la Plataforma, con base a la información personal
                provista por el mismo a Adium, la cual puede llegar a incluir su
                nombre, apellidos, número de cédula de identificación, fecha de
                nacimiento, dirección, teléfono, nombre de usuario, correo
                electrónico y demás información requerida para la correcta
                identificación del usuario.
              </p>
            </li>
            <li>
              <h2 className="text-xl">Condiciones de acceso</h2>
              <p className="text-sm text-justify opacity-60">
                El acceso a la Plataforma permite acceder a toda la información,
                productos y servicios contenidos en ella. El acceso a los
                Servicios requiere una autenticación del usuario identificado,
                previo diligenciamiento de un formulario básico de conocimiento
                del tercero interesado en hacer uso de la Plataforma.
              </p>
            </li>
            <li>
              <h2 className="text-xl">Reservas y responsabilidad de Adium</h2>
              <p className="text-sm text-justify opacity-60">
                El uso de la Plataforma será bajo el propio riesgo del Usuario.
                Adium no garantiza que las funciones técnicas y de operación de
                la Plataforma se brinden sin interrupciones o libres de errores,
                no obstante, Adium llevará a cabo las acciones que de acuerdo
                con sus posibilidades le permitan mantener el buen
                funcionamiento de la Plataforma. Adium no será responsable por
                ningún perjuicio que resulte de la imposibilidad de acceso o
                defectuoso funcionamiento de la misma. Adium no es ni será
                responsable por las caídas de la Plataforma y la falla en el
                suministro del servicio, quedando exonerado por cualquier tipo
                de daño o perjuicio causado debido a la no disponibilidad y/o
                interrupción del servicio que sean ajenos a su voluntad.
              </p>
              <p className="text-sm text-justify opacity-60">
                Los daños y perjuicios causados por virus informáticos,
                troyanos, código malicioso o cualesquiera otros sistemas físicos
                o lógicos a los sistemas de los usuarios no serán
                responsabilidad de Adium.
              </p>
            </li>
            <li>
              <h2 className="text-xl">
                Adium NO proporciona asesoramiento médico
              </h2>
              <p className="text-sm text-justify opacity-60">
                Adium <strong>NO</strong> actúa en calidad de profesional
                médico, por lo que cualquier tipo de indicación médica que el
                Usuario reciba, será pura y exclusiva responsabilidad del
                Profesional que brinde Servicios a través de la Plataforma. Al
                brindar el consentimiento, los Usuarios reconocen y eximen a
                Adium de cualquier tipo de responsabilidad que surja de la
                prestación médica que reciban. La Plataforma <strong>NO</strong>{" "}
                constituye asesoramiento médico. La Plataforma tiene como
                objetivo acercar a Usuarios y Profesionales para compartir
                información y comunicarse con el fin de dar cumplimiento a los
                Servicios. Adium ofrece sus contenidos como un servicio a los
                visitantes y deberían ser usados y entendidos con carácter
                informativo y no constituyen, bajo ningún punto de vista, una
                recomendación o sugerencia, ni pueden ser considerados
                asesoramiento médico. El acceso a la Plataforma y el uso de los
                Servicios no crea una relación médico/paciente con licencia
                entre el Usuario y Adium.
              </p>
              <p className="text-sm text-justify opacity-60">
                Adium <strong>NO</strong> ofrece garantía alguna de que la
                Plataforma satisfaga las necesidades del Usuario. Cualquier
                información médica que obtengas a través de la Plataforma debido
                a los Servicios es proporcionada únicamente por los
                Profesionales. Adium actúa simplemente como un conducto para
                dicha información. La Plataforma <strong>NO</strong> es una vía
                de contacto para emergencias médicas; en esos casos el Usuario
                debe llamar al 911. El Usuario es el único responsable de
                determinar la idoneidad del proveedor de servicios de salud para
                sus necesidades.
              </p>
            </li>
            <li>
              <h2 className="text-xl">
                Profesionales médicos, cumplimiento con leyes y regulación
                aplicable
              </h2>
              <p className="text-sm text-justify opacity-60">
                Adium y el Profesional han pactado que el cumplimiento de sus
                obligaciones en virtud del convenio de prestación de servicios
                profesionales que los une, no constituye ni crea relación alguna
                entre ellos que pudiera exceder del mismo y/o implicar la
                existencia de una sociedad de personas, sociedad por acciones,
                joint venture o cualquier otra clase de asociación temporaria o
                permanente, no pudiendo ninguno de ellos pretender la
                representación uno del otro, salvo que exista permiso explicito
                notificado de forma fehaciente.
              </p>
              <p className="text-sm text-justify opacity-60">
                Adium pone a disposición de los usuarios y clientes un espacio
                virtual de autogestión para acceder a diversos Servicios. Adium
                actúa como intermediario en el perfeccionamiento de las
                operaciones realizadas entre los Usuarios y los prestadores de
                salud, quienes conocen y aceptan ser los exclusivos responsables
                de los datos personales ingresados y de los servicios ofrecidos
                y/o prestados. Los Profesionales asumen la responsabilidad y
                obligación de contar con las credenciales habilitantes para el
                ejercicio profesional, además de cumplir con toda la normativa
                vigente y aplicable al desempeño de su profesión.
              </p>
              <p className="text-sm text-justify opacity-60">
                Al brindar el consentimiento, el Usuario permite que Adium
                proporcione información a los Profesionales para asegurar una
                correcta prestación de Servicios. Adium no proporciona
                asesoramiento legal, comercial o médico a los Profesionales.
                Adium no participa en la relación entre los Profesionales y los
                Usuarios. El Profesional reconoce y acepta que Adium no es parte
                en ninguna prestación de Servicios, ni tiene control sobre la
                calidad, la veracidad o exactitud de los Servicios prestados. Si
                en la Plataforma de Adium los Profesionales proporcionan
                ejemplos específicos de resultados, al Usuario se le informa que
                Adium no garantiza resultados. Los ejemplos sobre resultados
                publicitados son específicos para las personas representadas, no
                pueden garantizarse y no deben considerarse como típicos.
              </p>
              <p className="text-sm text-justify opacity-60">
                Adium no tiene la capacidad de garantizar que el Profesional
                cumplirá con las necesidades y expectativas del Usuario. El
                Usuario y el Profesional asumen la responsabilidad de cumplir
                con la programación y cumplimiento de citas u obligaciones que
                surjan del uso de la Plataforma.
              </p>
            </li>
            <li>
              <h2 className="text-xl">Cookies</h2>
              <p className="text-sm text-justify opacity-60">
                Se entiende por Cookies a los efectos de estos Términos y
                Condiciones a pequeños archivos de texto enviados por un sitio y
                que se guardan en el disco duro del dispositivo electrónico a
                través del cual se accede al mismo. La mayoría de los
                navegadores aceptan cookies automáticamente.
              </p>
              <p className="text-sm text-justify opacity-60">
                La Plataforma hace uso de cookies propias y de terceros a fin de
                optimizar la experiencia de navegación del Usuario.
              </p>
              <p className="text-sm text-justify opacity-60">
                Adium hará uso de cookies para determinar las preferencias de
                navegación del Usuario para efectos promocionales, comerciales y
                publicitarios, para efectos estadísticos, entre otros fines. Al
                aceptar estos Términos y Condiciones, usted acepta que Adium
                utilice cookies para los fines aquí señalados. El uso y
                navegación continuo en la Plataforma se entenderá como
                aceptación de los Términos y Condiciones y como consecuencia,
                del uso de las cookies.
              </p>
              <p className="text-sm text-justify opacity-60">
                No obstante, el Usuario podrá configurar su navegador para que
                notifique y rechace la instalación de las cookies enviadas por
                la Plataforma. Sin embargo, tenga en cuenta que al desactivar el
                uso de cookies usted podrá experimentar una disminución en el
                correcto funcionamiento de la Plataforma.
              </p>
            </li>
            <li>
              <h2 className="text-xl">Herramientas de Análisis y Rastreo</h2>
              <p className="text-sm text-justify opacity-60">
                Adium utiliza herramientas de análisis y rastreo de terceros,
                como Mixpanel y/o Hotjar, para mejorar la experiencia del
                usuario, optimizar el rendimiento de la Plataforma y analizar el
                comportamiento de los Usuarios.
              </p>
              <p className="text-sm text-justify opacity-60">
                Estas herramientas pueden recopilar información sobre tu
                dispositivo, tu navegación dentro de la aplicación, y otras
                interacciones con nuestro servicio. Esto puede incluir:
              </p>
              <ul className="text-sm text-justify opacity-60 mb-4">
                <li>Dirección IP</li>
                <li>Tipo de dispositivo</li>
                <li>Sistema operativo</li>
                <li>Páginas visitadas y duración de la visita</li>
                <li>
                  Acciones realizadas dentro de la aplicación (por ejemplo,
                  clics, desplazamientos)
                </li>
                <li>Información de ubicación aproximada</li>
              </ul>
              <p className="text-sm text-justify opacity-60">
                Adium a su vez, utiliza Mixpanel y Hotjar para realizar el
                seguimiento del comportamiento del Usuario a partir del
                servidor. El Usuario, al aceptar estos Términos y Condiciones
                declara conocer y aceptar que, aun en el caso en que se
                desactive la utilización de Cookies, Adium podrá continuar
                registrando su actividad a través de la Plataforma
              </p>
              <p className="text-sm text-justify opacity-60">
                Los datos recopilados pueden ser utilizados, entre otros fines,
                para:
              </p>
              <ul className="text-sm text-justify opacity-60 mb-4">
                <li>
                  Analizar y comprender cómo los Usuarios interactúan con
                  nuestra Plataforma
                </li>
                <li>Mejorar en las funcionalidades de la Plataforma</li>
                <li>
                  Identificar y corregir errores y problemas de rendimiento
                </li>
                <li>Desarrollar y probar nuevas funcionalidades</li>
              </ul>
              <p className="text-sm text-justify opacity-60">
                Adium podrá compartir la información con otras empresas de
                servicios o sitios de internet o similares a los fines de
                cumplir con las finalidades antes descritas. Generalmente dichas
                empresas o sitios de internet poseen sus propias políticas de
                privacidad de datos a los fines de su protección. De todas
                maneras, Adium empeñará sus mejores esfuerzos en que la
                privacidad de la información compartida sea protegida conforme a
                la legalidad vigente en cada momento. En los casos que
                corresponda, Adium intentará firmar acuerdos expresos en materia
                de protección de datos y de privacidad de la información. Sin
                perjuicio de ello, Adium no será responsable por los daños
                provocados por tales empresas y/o sitios de internet en cuanto a
                su deber de protección, confidencialidad y privacidad de los
                datos que ellas manejan.
              </p>
              <p className="text-sm text-justify opacity-60">
                Las herramientas de rastreo y seguimiento establecen cookies en
                el navegador de un visitante cuando este accede a un sitio web
                que carga el código de seguimiento de estas. Estas cookies
                permiten que el código de seguimiento de las herramientas
                funcione correctamente. Además de las cookies, el código de
                seguimiento también utiliza almacenamiento local y de sesión.
              </p>
              <p className="text-sm text-justify opacity-60">
                Al aceptar los Términos y Condiciones, el Usuario acepta y
                declara conocer los alcances y funcionalidades de herramientas
                de rastreo y seguimiento. En especial, Mixpanel y/o Hotjar.
              </p>
            </li>
            <li>
              <h2 className="text-xl">Links</h2>
              <p className="text-sm text-justify opacity-60">
                La Plataforma incluye dentro de sus contenidos enlaces con
                sitios pertenecientes y/o gestionados por terceros (“Sitios de
                terceros”) con el objeto de facilitar el acceso a información
                disponible a través de Internet. Adium no tiene control sobre
                Sitios de terceros. Fuera de la plataforma Adium estos Términos
                y Condiciones y Política de Privacidad de Datos no serán
                aplicables. El titular de éstos enlaces asume toda
                responsabilidad derivada de los contenidos en Sitios de
                Terceros; su vínculo/enlace no implica compartir las opiniones
                reflejadas en las mismas y respeta los derechos de propiedad
                intelectual que sus autores puedan poseer.
              </p>
            </li>
            <li>
              <h2 className="text-xl">Datos de dispositivos móviles</h2>
              <p className="text-sm text-justify opacity-60">
                Cuando los Usuarios descargan, instalan o utilizan la Plataforma
                en sus teléfonos celulares u otros dispositivos de
                telecomunicación inalámbricos, Adium automáticamente recopila
                información, que incluye sin limitación, los proveedores de
                telefonía, un identificador de dispositivo único, información de
                geoubicación (si el usuario lo permite), los tipos de
                dispositivos móviles que acceden a la Plataforma, y el tipo de
                sistemas operativos que acceden a la Plataforma (conjuntamente,
                "Datos de dispositivos móviles"). Un identificador de
                dispositivo único es un string de caracteres alfanuméricos
                (similar a un número de serie) utilizado para identificar y
                distinguir en forma única cada teléfono móvil u otro dispositivo
                de comunicación inalámbrico. Los servicios de ubicación se
                pueden habilitar o deshabilitar en cualquier momento, a través
                de los ajustes de los dispositivos móviles. Adium utiliza los
                Datos de dispositivos móviles para comprender los patrones de
                uso y mejorar la Plataforma.
              </p>
            </li>
            <li>
              <h2 className="text-xl">Política de privacidad</h2>
              <p className="text-sm text-justify opacity-60">
                Al utilizar la Plataforma usted acepta nuestra Política de
                Protección de Datos Personales. Para saber cómo manejamos la
                información, datos y contenidos facilitados por nuestros
                usuarios y visitantes consulte nuestra Política de Protección de
                Datos Personales disponible en la Plataforma.
              </p>
            </li>

            <li>
              <h2 className="text-xl">Reportes y denuncias</h2>
              <p className="text-sm text-justify opacity-60">
                Los Usuarios podrán reportar a Adium cualquier conducta o
                contenido que pueda infringir estos Términos y Condiciones,
                Política de Protección de Datos Personales o la legislación
                aplicable. Para tal efecto, la Plataforma contará con los
                canales idóneos para formular la respectiva PQRS. Recibida la
                solicitud, Adium, a su entera discreción, determinará si
                corresponde la eliminación o modificación del contenido.
              </p>
            </li>
            <li>
              <h2 className="text-xl">
                Modificaciones o terminación del sitio y sus productos y
                servicios
              </h2>
              <p className="text-sm text-justify opacity-60">
                Adium posee total autonomía, por lo cual se reserva el derecho
                discrecional de modificar, cambiar, aclarar, adicionar, remover,
                suprimir o prescindir, de manera unilateral, cualquier parte o
                la totalidad de la Plataforma, así como de estos Términos y
                Condiciones, modificando, cambiando, aclarando, adicionando,
                removiendo, suprimiendo o prescindiendo cualquiera de sus
                estipulaciones, en cualquier momento y sin previo aviso, según
                se considere necesario. Al usar la Plataforma después de que se
                hayan publicado las modificaciones y cambios, el Usuario acepta
                esas modificaciones y cambios. La terminación de los servicios
                y/o el cierre de la cuenta del Usuario, por cualquier causa, no
                generará compensación ni indemnización en su favor por parte de
                Adium.
              </p>
              <p className="text-sm text-justify opacity-60">
                En todo caso, Adium publicará la fecha en que la versión vigente
                de los Términos y Condiciones fue publicada, para fines
                informativos de los Usuarios de la Plataforma.
              </p>
            </li>
            <li>
              <h2 className="text-xl">Términos de ley</h2>
              <p className="text-sm text-justify opacity-60">
                Los presentes Términos y Condiciones serán gobernados e
                interpretados de acuerdo con las leyes de la República de
                Argentina, sin dar efecto a cualquier principio de conflictos de
                ley. Usuarios Internacionales: Si usted se encuentra fuera de
                Argentina y elige proporcionar Su información a Adium, Su
                información será transferida a Argentina y procesada allí (o a
                cualquier otro país en donde opere Adium). Al proveer sus datos
                personales y sensibles, utilizando la Plataforma, Usted acuerda
                y da su consentimiento para que Adium realice las acciones
                descriptas en el presente y su Política de Protección de Datos
                Personales.
              </p>
              <p className="text-sm text-justify opacity-60">
                Adium, los visitantes y Usuarios se someten a la jurisdicción de
                los Tribunales Ordinarios de la Ciudad Autónoma de Buenos Aires,
                renunciando a cualquier otro fuero o jurisdicción que pudiera
                corresponderles.
              </p>
              <p className="text-sm text-justify opacity-60">
                Estos Términos y Condiciones y la Política de Protección de
                Datos Personales constituyen el acuerdo completo entre el
                Usuario y Adium con respecto a los servicios, productos, uso y
                contenido de la Plataforma. Si alguna disposición de estos
                Términos y Condiciones es declarada ilegal, o presenta un vacío,
                o por cualquier razón resulta inaplicable, la misma deberá ser
                interpretada dentro del marco del mismo y en cualquier caso no
                afectará la validez y la aplicabilidad de las provisiones
                restantes.
              </p>
            </li>
            <li>
              <h2 className="text-xl">Domicilio</h2>
              <p className="text-sm text-justify opacity-60">
                A los fines establecidos en el presente, Adium fija domicilio en
                E57 KM16, Barrio Cuatro Hojas, Mendiolaza, CP 5107, Provincia de
                Córdoba , República Argentina.
              </p>
            </li>
          </ol>
        </Col>
      </Row>
      <Row>
        <Col ref={targetRef} className="mt-20 mb-4" span="24">
          <h1>
            <strong>POLÍTICAS Y PRIVACIDAD DE USO LA PLATAFORMA MOTIVIA</strong>
          </h1>

          <h2 className="text-sm text-justify opacity-100">
            <strong>Nombre o Razón Social:</strong> EIRA HEALTHCARE S.A.S.
          </h2>
          <h2 className="text-sm text-justify opacity-100">
            <strong>CUIT:</strong> 30-71744815-0
          </h2>
          <h2 className="text-sm text-justify opacity-100">
            <strong>Correo Electrónico:</strong>{" "}
            <a href="mailto:info@motivia.co">info@motivia.co</a>
          </h2>
          <p className="text-sm text-justify opacity-100">
            En virtud de lo establecido en la normativa vigente sobre Protección
            de Datos Personales, EIRA HEALTHCARE S.A.S. CUIT 30-71744815-0 (en
            adelante “Adium” o la “Sociedad”) valora su privacidad y desea que
            el titular se sienta tranquilo y seguro usando nuestro sitio web y
            aplicación (en adelante, la “Plataforma”). En este sentido, se ha
            implementado la presente Política de Protección de Datos Personales
            (en adelante, la “Política”), cuyos objetivos principales son, entre
            otros: (i) Informar la finalidad de Adium para el tratamiento de
            datos personales de los titulares; (ii) Informar las medidas de
            seguridad implementadas por Adium para la Protección de los Datos
            Personales e información y (iii) Informar los procedimientos de
            acceso, consulta y reclamación de los titulares sobre los Datos
            Personales.
          </p>
          <ol className="text-xl text-black">
            <li>
              <h2 className="text-xl">Fundamentos Jurídicos</h2>
              <p className="text-sm text-justify opacity-60">
                La presente Política se rige por lo dispuesto en la Ley de
                Protección de Datos Personales N°25.326, sus normas
                complementarias (Disposición 07/2010 de la Dirección Nacional de
                Protección de Datos Personales, el Decreto 1558/2001 y la
                Resolución 255/2022 de la Agencia de Acceso a la Información
                Pública) y toda aquella legislación que en un futuro complemente
                o derogue a éstas (en adelante la “Normativa aplicable”).
              </p>
            </li>
            <li>
              <h2 className="text-xl">Definiciones</h2>
              <p className="text-sm text-justify opacity-60">
                Para la interpretación de la presente Política, los términos que
                se mencionan en la misma se entenderán acorde a las definiciones
                establecidas en la actual Normativa aplicable.
              </p>
            </li>
            <li>
              <h2 className="text-xl">Consentimiento y su derecho de acceso</h2>
              <p className="text-sm text-justify opacity-60">
                El consentimiento de los titulares de Datos Personales o de
                quien se encuentre legitimado es requisito indispensable para
                que Adium recolecte, almacene, consulte, use, procese su
                información personal, ya sean datos personales o sensibles. Se
                entenderá que el Titular ha concedido el consentimiento de
                manera expresa e inequívoca a Adium para recolectar, almacenar,
                procesar o transferir sus datos cuando el mismo use o se
                registre en la Plataforma de Adium, entendiendo que acepta los
                términos de esta Política, así como también los Términos y
                Condiciones y la Política de Cookies. El consentimiento del
                Titular no será necesario cuando se trate de:
              </p>
              <ol className="list-roman text-sm text-justify opacity-60 mb-4">
                <li>
                  entrega de información requerida por una entidad pública o
                  administrativa en ejercicio de sus funciones legales o por
                  orden judicial;
                </li>
                <li>tratamiento sea sobre datos públicos;</li>
                <li>
                  del tratamiento de información autorizado por la ley para
                  fines históricos, estadísticos o científicos.
                </li>
              </ol>
            </li>
            <li>
              <h2 className="text-xl">Alcance</h2>
              <p className="text-sm text-justify opacity-60">
                La presente Política aplica al tratamiento y actividad sobre los
                datos de los que es responsable Adium. Por lo tanto, esta
                Política no cubre el tratamiento que hagan terceros de
              </p>
              <ol className="list-roman text-sm text-justify opacity-60 mb-4">
                <li>
                  Información recolectada en páginas, plataformas y/o
                  aplicaciones que no controle Adium, o
                </li>
                <li>Información recolectada por terceras partes.</li>
              </ol>
            </li>
            <li>
              <h2 className="text-xl">
                Finalidad del tratamiento de los datos personales
              </h2>
              <p className="text-sm text-justify opacity-60">
                Las finalidades para las cuales Adium tratará los Datos
                Personales y, que aplicarán de manera general a todos los
                Titulares, son:
              </p>
              <ol className="list-lower-alpha text-sm text-justify opacity-60 mb-4">
                <li>Cumplir el objeto social de Adium</li>
                <li>
                  Gestionar, administrar y usar toda la información necesaria
                  para el cumplimiento de las obligaciones legales y
                  contractuales de Adium así como las obligaciones tributarias,
                  comerciales, corporativas y contables.
                </li>
                <li>
                  Realizar análisis sobre los datos recolectados, con fines
                  estadísticos, científicos y académicos, incluyendo la
                  posibilidad de realizar publicaciones científicas, y
                  asegurando siempre que se evita la identificación de
                  titulares.
                </li>
                <li>
                  Guarda de los datos para el cumplimiento de los deberes que
                  como responsable de datos personales que le corresponde a
                  Adium.
                </li>
                <li>
                  Recolectar datos para el cumplimiento de los deberes que como
                  responsable de la información y datos personales le
                  corresponde a Adium.
                </li>
                <li>
                  Buscar la satisfacción de los Titulares respecto de los
                  productos y servicios ofrecidos por Adium.
                </li>
                <li>
                  Prestar mejores beneficios, productos y servicios a los
                  Titulares.
                </li>
                <li>
                  Personalizar la experiencia de los Titulares en la Plataforma
                  de Adium.
                </li>
                <li>
                  Realizar procesos al interior de la Sociedad, con fines de
                  desarrollo u operativo y/o de administración de sistemas.
                </li>
                <li>Mantener comunicación con el Titular.</li>
                <li>
                  Dar respuesta a preguntas, quejas, reclamos, peticiones,
                  solicitudes o comentarios de los Titulares.
                </li>
                <li>
                  Enviar información comercial y/o corporativa, así como
                  invitaciones a eventos y/o actividades que Adium organice.
                </li>
                <li>
                  Realizar seguimiento y rastreo de actividad del Usuario a
                  través de la Plataforma a fin de analizar métricas de
                  comportamiento mediante la utilización de herramientas y
                  software que permitan la mejora y optimización de experiencia
                  de Usuario a través de la Plataforma.
                </li>
                <li>
                  Identificar y mantener un registro y control de los
                  visitantes, proveedores, clientes, potenciales clientes,
                  accionistas, acreedores, colaboradores, aliados, empleados de
                  la Sociedad.
                </li>
                <li>
                  Proveer los servicios requeridos por sus clientes y acceder a
                  los servicios ofertados por sus proveedores.
                </li>
                <li>
                  Informar sobre nuevos servicios y/o sobre cambios en los
                  mismos.
                </li>
                <li>
                  Cumplir con la normativa vigente relacionada con el archivo y
                  custodia de la información.
                </li>
                <li>
                  Registrar y almacenar la información de los Titulares en las
                  Bases de Datos de la Sociedad.
                </li>
                <li>
                  Transmitir la información y los Datos Personales a terceros
                  involucrados en la prestación del servicio ofrecido.
                </li>
                <li>
                  Transmitir y/o transferir los Datos Personales del Titular, en
                  Argentina y al exterior, a empresas vinculadas o relacionadas,
                  a proveedores de bienes y servicios y aliados comerciales de
                  la Sociedad, según sea requerido para efectos del cumplimiento
                  de las obligaciones derivadas las relaciones comerciales,
                  civiles o laborales existentes con los Titulares.
                </li>
                <li>
                  Evaluar el uso de la Plataforma (de manera anónima e
                  integral), así como realizar estadísticas de las actividades
                  de los Titulares, como, por ejemplo, horas de visitas,
                  frecuencia con las que se visita y sitio web que transfirió a
                  la Plataforma, de manera que se personalice la experiencia de
                  los Titulares en la Plataforma.
                </li>
                <li>
                  Cualquier otra actividad de naturaleza similar a las
                  anteriormente descritas que sean necesarias para desarrollar
                  el objeto social de la Sociedad.
                </li>
                <li>
                  Cumplir con aquellos requerimientos hechos por autoridades
                  competentes dentro del marco legislativo nacional.
                </li>
              </ol>
            </li>
            <li>
              <h2 className="text-xl">
                Uso de Cookies, y herramientas de rastreo y seguimiento
              </h2>
              <p className="text-sm text-justify opacity-60">
                Adium utiliza cookies y otras herramientas que automáticamente
                recolectan información de las personas cuando usan la Plataforma
                de Adium, entendiendo que el ingreso y navegación en las mismas
                es una conducta inequívoca de consentimiento. El tipo de
                información que puede ser recolectada de esta manera incluye:
                Información sobre el localizador de recursos uniforme (URL),
                información acerca del explorador que utiliza el Titular,
                detalles de las páginas visitadas por el Titular, dirección IP,
                clicks, actividad e información de uso de la Plataforma e
                hipervínculos, entre otros.
              </p>
              <p className="text-sm text-justify opacity-60">
                Las herramientas de análisis y rastreo pueden recopilar varios
                tipos de información, incluyendo:
              </p>
              <ul className="text-sm text-justify opacity-60 mb-4">
                <li>
                  <strong>Información del dispositivo:</strong> tipo de
                  dispositivo, sistema operativo, identificadores únicos del
                  dispositivo.
                </li>
                <li>
                  <strong>Información de uso:</strong> páginas y pantallas
                  visitadas, tiempo pasado en la aplicación, clics y acciones
                  realizadas, rutas de navegación.
                </li>
                <li>
                  <strong>Información de ubicación:</strong> ubicación
                  geográfica aproximada basada en la dirección IP.
                </li>
                <li>
                  <strong>Información técnica:</strong> dirección IP, tipo de
                  navegador, proveedor de servicios de Internet.
                </li>
              </ul>
              <p className="text-sm text-justify opacity-60">
                Sin perjuicio de lo anterior, el usuario de la Plataforma puede
                deshabilitar o eliminar las cookies conforme al procedimiento
                establecido por cada navegador y dispositivo. En el caso de las
                herramientas de rastreo y seguimiento de actividad, estas
                permanecerán activas aún en el caso de que el Usuario
                deshabilite la utilización de cookies.
              </p>
              <p className="text-sm text-justify opacity-60">
                No obstante, frente a aquellos usuarios que deshabiliten las
                cookies, Adium informa que podría verse afectado el correcto
                funcionamiento de determinadas secciones de la Plataforma.
              </p>
            </li>
            <li>
              <h2 className="text-xl">
                Otras fuentes de recolección de datos personales
              </h2>
              <p className="text-sm text-justify opacity-60">
                Adium puede recibir información personal del Titular por medio
                de otras fuentes como bases de datos públicas e información de
                terceras partes a las que el Titular haya otorgado autorización
                para compartir su información. Adium no es responsable por la
                recolección de datos efectuada por terceros. Adium garantiza que
                la información recibida de terceras partes fue recolectada con
                el consentimiento de los Titulares, y el tratamiento de ésta es
                acorde a lo dispuesto por la normativa aplicable.
              </p>
            </li>
            <li>
              <h2 className="text-xl">
                Procedimiento de acceso, consulta y reclamación sobre datos
                personales
              </h2>
              <p className="text-sm text-justify opacity-60">
                Adium garantiza que los titulares de los datos personales a los
                que se les da tratamiento, tendrán acceso a éstos, y serán
                informados sobre todas las modificaciones, actualizaciones o
                supresiones que de ellos se haga, siempre y cuando soliciten
                dicha información. Los titulares podrán ejercer en cualquier
                momento el derecho de acceso a los datos personales que sean
                reunidos y tratados por Adium, conforme a la Normativa
                aplicable. En todo caso, los titulares en el ejercicio de su
                derecho al acceso de los datos deberán informar a Adium:
              </p>
              <ol className="list-lower-alpha text-sm text-justify opacity-60 mb-4">
                <li>Nombre completo.</li>
                <li>Número de identificación.</li>
                <li>Dirección de notificación o de respuesta.</li>
                <li>Teléfono de contacto.</li>
                <li>
                  Cuando el solicitante no sea el Titular, deberá acreditar el
                  interés por el acceso a la información junto con las
                  facultades que se le requieran según la Normativa aplicable.
                </li>
              </ol>
              <p className="text-sm text-justify opacity-60">
                Adium pone a disposición de los Titulares el siguiente correo{" "}
                <a href="mailto:info@motivia.co">info@motivia.co</a> al cual se
                deberá enviar la información mencionada, para presentar
                reclamos, solicitar actualización, rectificación o supresión,
                prueba del consentimiento brindado en su oportunidad y para
                ejercer los demás derechos mencionados anteriormente.
              </p>
              <p className="text-sm text-justify opacity-60">
                Cuando se trate de consultas, Adium tendrá un plazo de 10 días
                hábiles para dar respuesta, contados a partir de la fecha de
                recibo de las mismas. Cuando no fuere posible atender la
                consulta dentro de dicho término, se informará al interesado,
                expresando los motivos de la demora y señalando la fecha en que
                se atenderá su consulta, la cual en ningún caso podrá superar
                los 10 días hábiles siguientes al vencimiento del primer
                término.
              </p>
              <p className="text-sm text-justify opacity-60">
                Cuando se trate de reclamos, los mismos se formularán incluyendo
                la identificación del titular, la descripción de los hechos que
                dan lugar al reclamo, la dirección electrónica y los documentos
                de los que se quiera hacer valer. Si el reclamo resulta
                incompleto, se requerirá al interesado dentro de los 3 días
                siguientes a la recepción del reclamo para que subsane las
                fallas. Transcurridos 2 meses desde la fecha del requerimiento,
                sin que el solicitante presente la información requerida, se
                entenderá que ha desistido del reclamo.
              </p>
              <p className="text-sm text-justify opacity-60">
                La Agencia de Acceso a la Información Pública, órgano de control
                de la Ley Nº 25.326, tiene la atribución de atender las
                denuncias y reclamos que se interpongan con relación al
                incumplimiento de las normas sobre protección de datos
                personales.
              </p>
              <p className="text-sm text-justify opacity-60">
                Si el titular no está de acuerdo con los términos de nuestra
                Política de Privacidad o nuestros Términos y Condiciones o
                nuestra Política de Cookies, por favor no utilice la Plataforma
                de Adium ni proporcione sus datos personales a través de ellos.
              </p>
            </li>
            <li>
              <h2 className="text-xl">
                Suministro de datos personales a terceros - Transferencia y
                transmisión de datos personales
              </h2>

              <p className="text-sm text-justify opacity-60">
                Adium solo suministrará o dará acceso a terceros a la
                información personal de los Titulares cuando sea procedente o
                necesario según las finalidades ya mencionadas en la presente
                Política.
              </p>
              <p className="text-sm text-justify opacity-60">
                Así mismo, en caso de que sea necesario suministrar datos
                personales de los titulares a terceros encargados para que
                realicen el tratamiento en nombre de Adium, el titular autoriza
                a Adium a suministrar su información a esos terceros.
              </p>
              <p className="text-sm text-justify opacity-60">
                En caso de que en el cumplimiento de su objeto, Adium deba
                transferir datos personales de los Titulares a Responsables en
                diferentes países, al aceptar la presente Política el Titular lo
                autoriza y da su consentimiento expreso para dicha
                Transferencia, a cualquier país o territorio.
              </p>
              <p className="text-sm text-justify opacity-60">
                Asimismo, Adium garantiza que todo acceso a los datos
                transferidos se realizará:
              </p>

              <ol className="list-lower-alpha text-sm text-justify opacity-60 mb-4">
                <li>
                  por personal autorizado del Tercero que cumplirá con el deber
                  de confidencialidad y seguridad de estos.
                </li>
                <li>
                  que se ha verificado que la legislación local no impide el
                  cumplimiento de las obligaciones, garantías y principios en
                  esta Política de Privacidad de Datos
                </li>
                <li>
                  El tercero tratará los datos personales de conformidad con la
                  Ley Nº 25.326 de Protección de Datos Personales;
                </li>
                <li>
                  El tercero no cederá ni transferirá los datos personales a
                  terceros excepto que la cesión sea requerida por ley o
                  autoridad competente cuando constituya una medida necesaria
                  para la salvaguardia de la seguridad del Estado, la defensa,
                  la seguridad pública, la prevención, la investigación, la
                  detección y la represión de infracciones penales o
                  administrativas, o la protección del titular del dato o de los
                  derechos y libertades de otras personas.
                </li>
                <li>
                  En caso de que surja un conflicto vinculado a la protección de
                  datos de los Titulares, se entenderá que la la jurisdicción
                  judicial y administrativa son los Tribunales Ordinarios de la
                  Ciudad Autónoma de Buenos Aires..
                </li>
              </ol>
            </li>
            <li>
              <h2 className="text-xl">
                Medidas de seguridad para la protección de los datos personales
                y otra información
              </h2>
              <p className="text-sm text-justify opacity-60">
                Adium tomará las medidas necesarias para mantener seguros los
                datos personales de los titulares. Para ello Adium implementa
                varias medidas de seguridad y privacidad, entre las que se
                incluyen:
              </p>
              <ul className="text-sm text-justify opacity-60 mb-4">
                <li>
                  <strong>Minimización de datos:</strong> Se limita la
                  recopilación y el uso de datos personales a lo estrictamente
                  necesario para proporcionar los servicios.
                </li>

                <li>
                  <strong>Ocultación:</strong> Se emplean estándares de la
                  industria para proteger los datos confidenciales, incluyendo
                  técnicas de cifrado durante su transmisión y almacenamiento.
                </li>

                <li>
                  <strong>Control de acceso:</strong> Se restringe el acceso a
                  la información personal, permitiendo su tratamiento únicamente
                  a personal autorizado de Adium, o terceros a los cuales el
                  titular ha autorizado.
                </li>

                <li>
                  <strong>Autenticación:</strong> Adium protege las cuentas en
                  línea de los usuarios con métodos de autenticación robustos.
                </li>

                <li>
                  <strong>Transparencia:</strong> Se informa a los usuarios
                  sobre las prácticas de recopilación y uso de datos de manera
                  clara y accesible.
                </li>

                <li>
                  <strong>Cumplimiento:</strong> Adium se adhiere a todas las
                  leyes y regulaciones de privacidad aplicables en los
                  territorios donde opera.
                </li>
              </ul>
              <p className="text-sm text-justify opacity-60">
                Estas medidas se implementan a través de controles técnicos,
                administrativos y físicos, siguiendo los estándares de la
                industria. Además, Adium requiere que todo su personal cumpla
                con sus políticas y procedimientos de seguridad. Se exige a los
                terceros que ayudan a proporcionar los servicios, adoptar
                medidas de seguridad comparables.
              </p>
              <p className="text-sm text-justify opacity-60">
                A pesar de los esfuerzos por proteger la información personal,
                ningún sistema de seguridad es completamente impenetrable. Adium
                no puede garantizar la seguridad absoluta de sus sistemas, ni
                puede garantizar que la información suministrada no será
                interceptada mientras se transmite a través de Internet.
              </p>
              <p className="text-sm text-justify opacity-60">
                Se recomienda a los titulares de los datos tomar medidas para
                proteger su información personal, como mantener la
                confidencialidad de sus nombres de usuario y contraseñas, y
                cerrar sesión después de usar un dispositivo compartido.
              </p>

              <p className="text-sm text-justify opacity-60">
                En caso de que un Usuario hubiera eliminado su cuenta y luego
                solicite recuperarla, Adium seguirá el siguiente procedimiento:
              </p>
              <ol className="list-roman text-sm text-justify opacity-60 mb-4">
                <li>
                  Una vez eliminada la cuenta, Adium conservará durante 30 días
                  (Plazo de Recupero) la información correspondiente a datos de
                  usuario, en caso que este desee reactivar la cuenta.
                </li>
                <li>
                  Los datos de la cuenta quedarán almacenados durante el Plazo
                  de Recupero, en caso de que el Usuario desee reactivar su
                  cuenta.
                </li>
                <li>
                  En ese caso, el Usuario deberá enviar una solicitud a Adium
                  desde el correo electrónico de la cuenta asociada. En dicha
                  solicitud debe incluir:
                  <ul>
                    <li>Nombre completo.</li>
                    <li>Nombre de Usuario.</li>
                    <li>Fecha aproximada de eliminación de cuenta.</li>
                    <li>Motivo de eliminación y/o recupero de cuenta.</li>
                    <li>
                      Otro dato de interés a fin de hacer efectivo el recupero.
                    </li>
                  </ul>
                </li>
                <li>
                  El equipo de Adium podrá ponerse en contacto con el Usuario a
                  fin de solicitar información y/o documentación adicional a fin
                  de verificar la identidad antes de procesar la solicitud de
                  recupero. Esta información se utilizará exclusivamente para
                  verificar la identidad y no se conservará más allá de este
                  propósito.
                </li>
                <li>
                  Procesamiento de solicitud: Una vez verificados los datos y la
                  identidad, se procederá a restaurar la cuenta y datos
                  asociados
                </li>
                <li>
                  Adium se reserva el derecho de aceptar o rechazar el recupero
                  de la cuenta eliminada.
                </li>
                <li>
                  El recupero de la cuenta eliminada está sujeta a las
                  siguientes limitaciones:
                  <ul>
                    <li>
                      Disponibilidad de datos: Si los datos han sido eliminados
                      permanentemente debido al cumplimiento de las Políticas de
                      retención de datos, no será posible recuperar la cuenta.
                    </li>
                    <li>
                      Cambios en la cuenta: Modificación o eliminación en datos
                      asociados a la cuenta eliminada, de imposible restauración
                      por parte de Adium
                    </li>
                  </ul>
                </li>
                <li>
                  Confirmación de recupero: Una vez que la solicitud haya sido
                  procesada, el Usuario recibirá una confirmación por parte de
                  Adium confirmando el recupero de la cuenta. El Usuario podrá
                  acceder a su cuenta con las credenciales originales, o bien
                  recibir instrucciones a fin de restablecer el acceso.
                </li>
                <li>
                  Vencido el plazo de recupero de datos, los datos personales
                  del Usuario serán eliminados de nuestra base de datos.
                </li>
              </ol>
            </li>
            <li>
              <h2 className="text-xl">
                Vigencia y modificaciones de la política de tratamiento de datos
                personales
              </h2>

              <p className="text-sm text-justify opacity-60">
                La presente Política de Protección de Datos se encuentra vigente
                a partir del 01 de julio de 2023.
              </p>
              <p className="text-sm text-justify opacity-60">
                Una vez se cumpla(n) las finalidad(es) y siempre que no exista
                un deber legal o contractual de conservar su información, sus
                datos serán eliminados de nuestras bases de datos. El plazo
                máximo de conservación de los datos será de 5 años.
              </p>
              <p className="text-sm text-justify opacity-60">
                Cualquier cambio o modificación sustancial de la presente
                Política será comunicado oportunamente a los titulares mediante
                la publicación en el sitio web de Adium{" "}
                <a href="https://www.motivia.co">www.motivia.co</a>, donde se
                pondrá a disposición de los titulares, la última versión de la
                misma, indicando la fecha de entrada en vigencia de la
                correspondiente modificación.
              </p>
            </li>
          </ol>
          <p className="mt-28 text-center">
            Ultima actualización: 23 de mayo 2024
          </p>
        </Col>
      </Row>
    </div>
  );
};

export default Terms;
